<template>

  <div style="padding: 10px 10px;">
    <el-row>
      <el-badge :value="total" class="item">
        <el-button @click="handleClick(1)" :class="active == 1 ? 'active' : ''" size="large">本人任务</el-button>
      </el-badge>
      <el-badge :value="totalAudit" class="item" style="margin-left: 30px;">
        <el-button @click="handleClick(2)" :class="active == 2 ? 'active' : ''" size="large">审阅任务</el-button>
      </el-badge>
    </el-row>
    <div style="margin-top: 30px;">
      <el-form ref="queryForm" :inline="true" :model="form" label-width="80px">
        <el-form-item label="任务编号">
          <el-input v-model="form.taskId"></el-input>
        </el-form-item>
        <el-form-item label="门店">
          <el-select v-model="form.shopName" placeholder="请选择门店">
            <el-option
                v-for="item in optionStore"
                :key="item.shopName"
                :label="item.shopName"
                :value="item.shopName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务名称">
          <el-input v-model="form.taskName"></el-input>
        </el-form-item>
        <el-form-item label="任务状态">
          <el-select v-model="form.statusNew" placeholder="请选择">
            <el-option
                v-for="item in optionStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="处理时间">
          <el-input v-model="form.dealTime"></el-input>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-input v-model="form.auditStatus"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button style="margin-left: 10px;" type="primary" @click="search">查询</el-button>
          <el-button type="reset" @click="reset">重置</el-button>
          <el-button type="warning" @click="back">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 30px;">
      <div>
        <el-table
            :data="tableData"
            style="width: 100%;">
          <el-table-column
              prop="id"
              label="任务编号"
              width="120">
          </el-table-column>
          <el-table-column
              prop="mdName"
              label="门店"
              width="80">
          </el-table-column>
          <el-table-column
              prop="title"
              label="任务名称"
              width="120">
          </el-table-column>
          <el-table-column
              prop="reply"
              label="回复主题"
              width="120">
          </el-table-column>
          <el-table-column
              prop="editor"
              label="处理人"
              width="100">
          </el-table-column>
          <el-table-column
              prop="auditor"
              label="审阅人"
              width="100">
          </el-table-column>
          <el-table-column
              label="状态"
              width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">待处理</span>
              <span v-if="scope.row.status == 1">已处理</span>
              <span v-if="scope.row.status == 2">已过期</span>
              <span v-if="scope.row.status == 4">已审阅</span>
              <span v-if="scope.row.status == 1 && scope.row.isOver">逾期处理</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="createDate"
              label="推送时间"
              width="150">
          </el-table-column>
          <el-table-column
              prop="dealTime"
              label="处理时间"
              width="80">
          </el-table-column>
          <el-table-column
              prop="auditTime"
              label="审阅时间"
              width="160">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  @click="handleView(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination align='center'
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pageNum"
                       :page-sizes="[10, 20, 30, 40, 50]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       style="margin-top: 10px;float: right;margin-bottom: 200px;height: 150px;"
                       :total="totalIn">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import AlarmOrderApi from "../../../api/alarm/order/AlarmOrderApi";
import {default as PermissionApi} from "@/api/smp/auth/Permission";
import StoreApi from "../../../api/pd/common/StoreApi";
export default {
  name: "taskDetail",
  props: {
    role: {
      type: Number
    },
    item: {
      type: Object,
      default: null
    },
    page: {
      type: Object,
      default: null
    },
    searchData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      active: 1,
      form: {
        taskId: '',
        taskName: '',
        shopName: '',
        statusNew: '',
        audit: '',
        isSend: '',
        dealTime: '',
        auditStatus: ''
      },
      tableData: [],
      optionStore: [],
      total: 0,
      totalAudit: 0,
      totalIn: 0,
      pageNum: 1,
      pageSize: 10,
      buttonPriviledgeList: [],
      optionStatus: [
        {label: '待处理', value: 0},
        {label: '已处理', value: 1},
        {label: '已过期', value: 2},
        {label: '已审阅', value: 4}
      ]
    }
  },
  created() {
    this.getButtonPriviledge()
    this.getStore()
    console.log(this.searchData)
  },
  mounted() {
    console.log(this.audit)

    if (this.searchData != null) {
      this.active = this.searchData.active
      this.form = this.searchData.form
      this.pageNum = this.searchData.pageNum
      this.pageSize = this.searchData.pageSize

      this.search()
    } else {
      this.getTaskAllList()
      this.getTaskMountInfo()
    }
  },
  methods: {
    // 获取门店列表
    getStore() {
      let that = this
      StoreApi.queryStoreList().then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.optionStore = res.data.shopPriviledges
          console.log(that.optionStore)
        } else {
          that.$message.error(res.msg)
        }
      }).catch(error => {
        console.log(error)
        that.$message.warning('系统错误！请稍后尝试')
      })
    },
    // 获取预警任务统计
    getTaskMountInfo() {
      let that = this
      AlarmOrderApi.getTaskCountInfo({type: 1, role: this.role}).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.taskAmountInfo = res.data
          let num = 0
          let dataIn = res.data
          if (dataIn.length > 0) {
            dataIn.map(item => {
              if (item.status == 4) {
                that.totalAudit = item.amount
              } else {
                if (item.amount) {
                  num += item.amount
                }
              }
            })
          }
          that.total = num
        } else {
          alert(res.msg)
        }
      }).catch(error => {
        console.log(error)
        alert('系统错误！')
      })
    },
    handleSizeChange(val) {
      console.log(val)
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      console.log(val)
      this.pageNum = val
      this.search()
    },
    getTaskAllList() {
      let that = this
      let params = {
        taskType: 2,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      AlarmOrderApi.getTaskAllList(params).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.tableData = res.data.rows
          that.tableData.map(item => {
            item.createDate = that.timeFormatSeconds(item.createDate)
            item.auditTime = item.auditTime == null ? '' : that.timeFormatSeconds(item.auditTime)
            item.dealTime = item.dealTime != null ? that.timeFormatSeconds(item.dealTime) : ''
          })
          that.totalIn = res.data.total
        }
      })
    },
    getTaskAuditList() {
      let that = this

      let params = {
        taskType: 2,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        role: this.role == 1 ? 1 : ''
      }
      AlarmOrderApi.getTaskAuditList(params).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.tableData = res.data.rows
          that.tableData.map(item => {
            item.createDate = that.timeFormatSeconds(item.createDate)
            item.auditTime = item.auditTime == null ? '' : that.timeFormatSeconds(item.auditTime)
            item.dealTime = item.dealTime != null ? that.timeFormatSeconds(item.dealTime) : ''
          })
          that.totalIn = res.data.total
        }
      })
    },
    handleClick(val) {
      console.log(val)
      this.active = val
      this.pageNum = 1
      this.form.statusNew = ''
      if (val == 1) {
        this.getTaskAllList()
      } else {
        this.getTaskAuditList()
      }
    },

    search() {
      let that = this
      let  params = this.form
      params.taskType = 2
      params.pageNum = this.pageNum
      params.pageSize = this.pageSize
      params.role = this.role == 1 ? 1 : ''
      if (this.active == 1) {
        AlarmOrderApi.getTaskAllList(params).then(res => {
          console.log(res)
          res = res.data
          if (res.code == 200) {
            that.tableData = res.data.rows
            that.tableData.map(item => {
              item.createDate = that.timeFormatSeconds(item.createDate)
              item.auditTime = item.auditTime == null ? '' : that.timeFormatSeconds(item.auditTime)
              item.dealTime = item.dealTime != null ? that.timeFormatSeconds(item.dealTime) : ''
            })
            that.totalIn = res.data.total
          }
        })
      } else {
        AlarmOrderApi.getTaskAuditList(params).then(res => {
          console.log(res)
          res = res.data
          if (res.code == 200) {
            that.tableData = res.data.rows
            that.tableData.map(item => {
              item.createDate = that.timeFormatSeconds(item.createDate)
              item.auditTime = item.auditTime == null ? '' : that.timeFormatSeconds(item.auditTime)
              item.dealTime = item.dealTime != null ? that.timeFormatSeconds(item.dealTime) : ''
            })
            that.totalIn = res.data.total
          }
        })
      }
    },
    reset() {
      this.form.resetFields()
    },
    handleView(index, row) {
      console.log(row)
      let type = 0
      if (row.status == 1 || row.status == 4) {
        type = "1"
      }
      let searchIn = {
        active: this.active,
        form: this.form,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$emit("addCallbackTask", {formStatus:'task', item: row, type: type, return: 2, audit: this.active, searchData: searchIn})
    },
    // 返回
    back() {
      this.$emit("back")
    },
    // 时间戳转换
    timeFormatSeconds(time) {
      var d = time ? new Date(time) : new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hours = d.getHours();
      var min = d.getMinutes();
      var seconds = d.getSeconds();

      if (month < 10) month = '0' + month;
      if (day < 10) day = '0' + day;
      if (hours < 10) hours = '0' + hours;
      if (min < 10) min = '0' + min;
      if (seconds < 10) seconds = '0' + seconds;

      return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds);
    },

    getButtonPriviledge(){
      console.log('this.page',this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
        PermissionApi.handleResponse(resp, me, function (data){
          me.buttonPriviledgeList = data.buttonPriviledges
          console.log('buttonPriviledgeList',me.buttonPriviledgeList)
        })
      })
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton = false
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == 'Y') {
            return true
          } else {
            return false
          }
        }
      }
      return false
    }
  }
}
</script>

<style scoped>
  .item {
    margin-top: 10px;
    margin-right: 10px;
  }
  .active {
    border:1px solid deepskyblue;
  }

  .component-fade-enter-active {
    transition: all 3s ease;
  }
  .component-fade-leave-active {
    transition: all 8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .component-fade-fade-enter, .component-fade-leave-active {
    transform: translateX(10px);
    opacity: 0;
  }
</style>